import { createDecorator } from '@tencent/containerized';
export var IAuthDomainService = createDecorator('IAuthDomainService');
